import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای PrintFormatFamilyDetailPage

<Alert variant="info">
محتوای راهنمای این صفحه به زودی تکمیل خواهد شد.
</Alert>

export default Layout;
